import { apiUrl, apiToken } from '@/configs/config'

export type PendingConsent = {
    consentMasterId: number
    consentCode: string
    consentTitle: string
    consentPurpose: string
    consentVersionId: number
    versionNo: string
    consentText: string
    languageCode: string
}

export const apiGetPendingConsents = async (
    empCode: string,
): Promise<PendingConsent[]> => {
    try {
        const response = await fetch(`${apiUrl}/consent/pending`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${apiToken}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ empCode }),
        })

        const result = await response.json()

        if (result?.statusCode === 0 && Array.isArray(result.responseContent)) {
            return result.responseContent
        }

        return []
    } catch (error) {
        console.error('Error fetching pending consents:', error)
        return []
    }
}

export const apiSubmitConsent = async (
    empCode: string,
    consentVersionId: number,
    consentStatus: 'ACCEPTED' | 'REJECTED',
): Promise<{ success: boolean; message: string; pendingConsents: PendingConsent[] }> => {
    try {
        const response = await fetch(`${apiUrl}/consent/submit`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${apiToken}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ empCode, consentVersionId, consentStatus }),
        })

        const result = await response.json()

        if (result?.statusCode === 0) {
            return {
                success: true,
                message: result.message || '',
                pendingConsents: Array.isArray(result.responseContent)
                    ? result.responseContent
                    : [],
            }
        }

        return {
            success: false,
            message: result?.errorDescription || 'Unable to record consent',
            pendingConsents: [],
        }
    } catch (error) {
        console.error('Error submitting consent:', error)
        return {
            success: false,
            message: 'Server error. Please try again later.',
            pendingConsents: [],
        }
    }
}
